module.exports = __webpack_public_path__ + "img/loveNovel-success.c668feb7.png";